import { Component } from "@angular/core";
import { HelperService } from "../../../../../common-items/services/helper.service";

@Component({
    selector : 'sucess-page',
    templateUrl : './bass-sca-sucess-page.component.html',
    styleUrls : ['./bass-sca-sucess-page.component.less']
})

export class BassScaSucessPageComponent {
    redirectText:string ='';
    constructor(public helperService :HelperService){

    }

    ngOnInit(): void {
        this.redirectText = this.helperService.getCodeText('RESET_PASSWORD.BTN_BCK_TO_LOGIN');
    }
}